module.exports = __webpack_public_path__ + "img/pr-5.b7d4269e.png";